import script from "./CoverageStatusFilterChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageStatusFilterChips.vue?vue&type=script&setup=true&lang=ts"

import "./CoverageStatusFilterChips.vue?vue&type=style&index=0&id=6613505f&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6613505f"]])

export default __exports__